var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "130",
        height: "34",
        viewBox: "0 0 130 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M119.755 23.7419H119.445C119.397 24.2199 119.35 24.6263 119.278 24.937C119.23 25.2478 119.111 25.6063 118.968 25.9888C119.397 26.3473 119.946 26.6581 120.589 26.921C121.233 27.2078 122.068 27.3274 123.117 27.3274C124.094 27.3274 124.952 27.1839 125.715 26.921C126.478 26.6342 127.122 26.2517 127.646 25.7497C128.171 25.2478 128.576 24.6502 128.839 23.957C129.125 23.2638 129.244 22.5467 129.244 21.7818C129.244 20.8496 129.053 20.1325 128.648 19.5588C128.266 19.0091 127.766 18.5549 127.194 18.1964C126.597 17.8378 125.978 17.551 125.31 17.3119C124.642 17.0729 123.999 16.7861 123.427 16.4753C122.831 16.1646 122.354 15.7821 121.948 15.328C121.567 14.8738 121.352 14.2523 121.352 13.4635C121.352 13.0094 121.424 12.603 121.591 12.1967C121.758 11.8142 121.972 11.4796 122.258 11.1927C122.544 10.9059 122.902 10.7147 123.283 10.5474C123.665 10.4039 124.118 10.3322 124.571 10.3322C125.048 10.3322 125.429 10.4039 125.763 10.5713C126.097 10.7386 126.383 10.9298 126.621 11.1688C126.86 11.4079 127.05 11.6469 127.194 11.9337C127.337 12.2206 127.456 12.4596 127.527 12.6986H127.837C127.933 12.2206 128.028 11.8142 128.147 11.5035C128.243 11.1927 128.362 10.882 128.529 10.5952C128.028 10.1888 127.48 9.90197 126.907 9.71074C126.311 9.51952 125.62 9.4239 124.833 9.4239C123.999 9.4239 123.236 9.54342 122.568 9.78245C121.901 10.0215 121.328 10.3322 120.852 10.7625C120.375 11.1927 120.017 11.6708 119.755 12.2684C119.493 12.8421 119.373 13.4874 119.373 14.1806C119.373 15.1607 119.564 15.9495 119.97 16.547C120.351 17.1446 120.852 17.6227 121.424 17.9812C122.02 18.3637 122.64 18.6744 123.307 18.9135C123.975 19.1764 124.619 19.4393 125.191 19.7501C125.787 20.0608 126.264 20.4193 126.645 20.8735C127.027 21.3277 127.241 21.9491 127.241 22.714C127.241 23.216 127.146 23.6941 126.979 24.1243C126.812 24.5785 126.574 24.9609 126.264 25.2717C125.954 25.6063 125.572 25.8693 125.143 26.0605C124.69 26.2517 124.213 26.3473 123.641 26.3473C123.117 26.3473 122.616 26.2756 122.187 26.1083C121.758 25.941 121.376 25.7497 121.042 25.4868C120.709 25.2239 120.446 24.9609 120.208 24.6502C120.089 24.3395 119.898 24.0287 119.755 23.7419ZM103.877 23.7419H103.567C103.519 24.2199 103.471 24.6263 103.4 24.937C103.352 25.2478 103.233 25.6063 103.09 25.9888C103.519 26.3473 104.067 26.6581 104.711 26.921C105.355 27.2078 106.189 27.3274 107.238 27.3274C108.216 27.3274 109.074 27.1839 109.837 26.921C110.6 26.6342 111.244 26.2517 111.768 25.7497C112.293 25.2478 112.698 24.6502 112.96 23.957C113.246 23.2638 113.365 22.5467 113.365 21.7818C113.365 20.8496 113.175 20.1325 112.769 19.5588C112.388 19.0091 111.887 18.5549 111.291 18.1964C110.695 17.8378 110.075 17.551 109.408 17.3119C108.74 17.0729 108.096 16.7861 107.524 16.4753C106.928 16.1646 106.451 15.7821 106.07 15.328C105.688 14.8738 105.474 14.2523 105.474 13.4635C105.474 13.0094 105.545 12.603 105.712 12.1967C105.879 11.8142 106.094 11.4796 106.38 11.1927C106.666 10.9059 107.024 10.7147 107.405 10.5474C107.787 10.4039 108.24 10.3322 108.693 10.3322C109.169 10.3322 109.551 10.4039 109.885 10.5713C110.218 10.7386 110.504 10.9298 110.743 11.1688C110.981 11.4079 111.172 11.6469 111.315 11.9337C111.458 12.2206 111.577 12.4596 111.649 12.6986H111.959C112.054 12.2206 112.15 11.8142 112.269 11.5035C112.364 11.1927 112.483 10.882 112.65 10.5952C112.15 10.1888 111.601 9.90197 111.029 9.71074C110.433 9.51952 109.742 9.4239 108.955 9.4239C108.12 9.4239 107.357 9.54342 106.69 9.78245C106.022 10.0215 105.45 10.3322 104.973 10.7625C104.496 11.1927 104.139 11.6708 103.877 12.2684C103.614 12.8421 103.495 13.4874 103.495 14.1806C103.495 15.1607 103.686 15.9495 104.091 16.547C104.473 17.1446 104.973 17.6227 105.569 17.9812C106.165 18.3637 106.785 18.6744 107.453 18.9135C108.12 19.1764 108.764 19.4393 109.336 19.7501C109.932 20.0608 110.409 20.4193 110.814 20.8735C111.196 21.3277 111.41 21.9491 111.41 22.714C111.41 23.216 111.315 23.6941 111.148 24.1243C110.981 24.5785 110.743 24.9609 110.433 25.2717C110.123 25.6063 109.742 25.8693 109.312 26.0605C108.859 26.2517 108.383 26.3473 107.81 26.3473C107.286 26.3473 106.785 26.2756 106.356 26.1083C105.927 25.941 105.545 25.7497 105.212 25.4868C104.878 25.2239 104.616 24.9609 104.377 24.6502C104.186 24.3395 104.02 24.0287 103.877 23.7419ZM97.5108 25.2478C97.1771 24.4829 96.7956 23.5985 96.3665 22.6184C95.9373 21.6384 95.4843 20.5867 95.0075 19.4393C94.5307 18.292 94.03 17.1446 93.5532 15.9973C93.0763 14.8499 92.5995 13.7026 92.1227 12.5791C91.6458 11.4557 91.2167 10.4039 90.8114 9.4239H90.3346C89.0233 12.4118 87.7358 15.3758 86.4484 18.2681C85.161 21.1603 83.8497 24.0765 82.4907 27.0166C82.7768 26.9927 83.0867 26.9688 83.4205 26.9688C83.7543 26.9688 84.0642 26.9927 84.3503 27.0166C84.5649 26.2517 84.8987 25.2717 85.3278 24.1004C85.757 22.9292 86.2577 21.6862 86.7822 20.3715C87.3067 20.3476 87.8074 20.3476 88.308 20.3237C88.8087 20.3237 89.3094 20.2998 89.8339 20.2998C90.3822 20.2998 90.9306 20.2998 91.4789 20.3237C92.0273 20.3237 92.5757 20.3476 93.1002 20.3715C93.3147 20.9213 93.5532 21.495 93.7916 22.1165C94.0538 22.738 94.2922 23.3355 94.5307 23.9331C94.7691 24.5307 94.9836 25.1044 95.1982 25.6302C95.389 26.18 95.5558 26.6342 95.6751 27.0166C95.9135 26.9927 96.128 26.9688 96.3426 26.9688H97.0102H97.6777C97.8923 26.9688 98.1069 26.9927 98.3453 27.0166C98.1307 26.6103 97.8446 26.0127 97.5108 25.2478ZM89.9769 12.7942L92.7664 19.1764C92.2896 19.2003 91.8366 19.2003 91.3597 19.2242C90.8829 19.2242 90.4299 19.2481 89.9531 19.2481C89.5239 19.2481 89.071 19.2481 88.5941 19.2242C88.1173 19.2003 87.6643 19.2003 87.2352 19.2003L89.9769 12.7942ZM68.4719 16.2602V20.5867C68.4719 21.6862 68.4481 22.7858 68.4004 23.8614C68.3527 24.937 68.305 25.9888 68.2573 27.0166C69.0679 26.9927 69.8309 26.9688 70.57 26.9688H72.8826H75.1952C75.9581 26.9688 76.7211 26.9927 77.5078 27.0166C77.4125 26.7537 77.3886 26.5146 77.3886 26.3473C77.3886 26.1561 77.4363 25.8932 77.5078 25.5824C76.2442 25.7497 75.076 25.8454 74.0031 25.8693C72.9064 25.8932 71.7859 25.9171 70.5938 25.9171C70.57 24.698 70.57 23.3116 70.5461 21.7579C70.5223 20.2042 70.5223 18.3876 70.5223 16.2602C70.5223 15.1607 70.5461 14.0611 70.5938 13.0094C70.6415 11.9576 70.6892 10.8581 70.7369 9.75855C70.5223 9.78245 70.3077 9.83026 70.117 9.85416C69.9262 9.87806 69.7117 9.90197 69.5209 9.90197C69.3302 9.90197 69.1156 9.87806 68.9249 9.85416C68.7342 9.83026 68.5196 9.80635 68.305 9.75855C68.3527 10.8581 68.4004 11.9576 68.4481 13.0094C68.4481 14.0611 68.4719 15.1368 68.4719 16.2602ZM61.2003 25.9649L61.4148 24.4829L61.3195 24.3873C61.0811 24.5785 60.795 24.7936 60.4612 25.0327C60.1274 25.2717 59.7459 25.5107 59.3168 25.7019C58.8876 25.9171 58.4108 26.0844 57.9101 26.2517C57.4095 26.3951 56.8373 26.4668 56.2412 26.4668C55.2637 26.4668 54.3339 26.2995 53.4995 25.9888C52.665 25.678 51.9259 25.1761 51.2822 24.5068C50.6623 23.8375 50.1617 23.0009 49.8279 21.997C49.4702 20.993 49.3034 19.774 49.3034 18.3876C49.3034 17.0012 49.4702 15.806 49.8279 14.7782C50.1855 13.7743 50.6623 12.9377 51.2822 12.2684C51.9021 11.5991 52.6412 11.121 53.4995 10.8103C54.3339 10.4995 55.2637 10.3322 56.2412 10.3322C56.8373 10.3322 57.3856 10.4039 57.8863 10.5713C58.387 10.7386 58.84 10.9298 59.2453 11.1688C59.6506 11.4079 60.0082 11.6469 60.2943 11.8859C60.6042 12.1489 60.8188 12.364 60.9857 12.5552L61.1287 12.5074C61.1764 12.2445 61.2479 11.9098 61.3195 11.5035C61.391 11.0971 61.5102 10.7864 61.6532 10.5474C60.9618 10.2366 60.1512 9.94977 59.2453 9.73465C58.3393 9.51952 57.3379 9.4 56.2174 9.4C54.8346 9.4 53.571 9.59123 52.4027 9.99758C51.2584 10.4039 50.257 10.9776 49.4226 11.7664C48.5881 12.5313 47.9444 13.4874 47.4914 14.587C47.0384 15.7104 46.8 16.9773 46.8 18.3876C46.8 19.8218 47.0384 21.0886 47.4914 22.1882C47.9444 23.3116 48.5881 24.2439 49.3987 25.0088C50.2093 25.7737 51.163 26.3473 52.2835 26.7298C53.4041 27.1122 54.62 27.3035 55.9313 27.3035C56.5512 27.3035 57.1472 27.2556 57.7194 27.16C58.2916 27.0644 58.7923 26.9449 59.2691 26.8254C59.7221 26.7059 60.1274 26.5625 60.4373 26.3951C60.8188 26.2517 61.0572 26.1083 61.2003 25.9649Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M3.86815 27.8468L5.8468 24.4051C6.68117 22.9472 8.23071 22.0629 9.89945 22.0629H14.7626H17.4803C17.2419 21.3458 16.9082 20.6288 16.4552 19.9596C13.9044 16.0638 8.7075 14.797 4.65484 17.0198C0.173077 19.4816 -1.35263 25.2177 1.31736 29.5916C3.72511 33.5591 8.87437 35.0409 13.0224 32.9377C15.2156 31.8382 16.7175 29.974 17.4565 27.8468H3.86815Z",
          fill: "url(#paint0_linear_7343_80695)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M32.2844 27.8468H28.3271C26.6584 27.8468 25.1088 26.9625 24.2745 25.5046L21.8429 21.298L20.484 18.9558C19.9834 19.5294 19.5305 20.1747 19.1729 20.9156C17.0989 25.0743 18.5769 30.213 22.558 32.627C26.9445 35.2799 32.642 33.7503 35.0974 29.2331C37.3145 25.146 36.0272 19.9357 32.1414 17.4022C30.0912 16.0638 27.7073 15.6814 25.5141 16.1116L32.2844 27.8468Z",
          fill: "url(#paint1_linear_7343_80695)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M18.0763 3.15739L20.0549 6.5991C20.8893 8.05704 20.8893 9.82569 20.0549 11.2836L17.6233 15.4902L16.2645 17.8324C17.0035 17.9758 17.7902 18.0475 18.6007 17.9997C23.2255 17.7368 26.9445 13.8649 27.0398 9.20427C27.159 4.06562 22.9633 -0.117005 17.8379 0.0024987C13.1893 0.122002 9.35115 3.85051 9.08892 8.48725C8.94589 10.949 9.8041 13.1957 11.2821 14.8926L18.0763 3.15739Z",
          fill: "url(#paint2_linear_7343_80695)"
        }
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_7343_80695",
                x1: "0.0959337",
                y1: "29.036",
                x2: "16.3839",
                y2: "21.4603",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#017C91" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.2159", "stop-color": "#03788E" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.4396", "stop-color": "#076B84" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.6669", "stop-color": "#0F5774" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.8953", "stop-color": "#1A3A5D" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#202A51" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear_7343_80695",
                x1: "35.4212",
                y1: "30.6576",
                x2: "20.6881",
                y2: "20.368",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                attrs: { offset: "0.000251257", "stop-color": "#AE638E" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.2495", "stop-color": "#AA638F" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.5077", "stop-color": "#9D6490" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.7691", "stop-color": "#896593" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#706697" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint2_linear_7343_80695",
                x1: "18.9424",
                y1: "-0.931206",
                x2: "17.3695",
                y2: "17.0012",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#B3D1BD" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.1493", "stop-color": "#AFD0BC" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.304", "stop-color": "#A2CDB8" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.4613", "stop-color": "#8EC9B2" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.6204", "stop-color": "#71C3AA" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.7808", "stop-color": "#4BBB9F" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.9402", "stop-color": "#1EB192" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#0BAD8D" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }